import * as React from "react";
import { motion } from "framer-motion";
import { OpenChatMessage } from "@/types/open-chat";
import { User } from "lucide-react";
import * as S from "./messageRowUser.styled";
import { OpenChatMessageRowImprove } from "./messageRowImprove";
import { MarkdownRenderer } from "@/components/feature/markdown/markdownRenderer";
import { OpenChatMessageRowAddToPromptLibrary } from "@/views/open-chat/components/message/messageRowAddToPromptLibrary";
import { twMerge } from "tailwind-merge";

interface Props {
  message: OpenChatMessage;
  allowImprovement?: boolean;
  onImprovePrompt?: () => void;
  hideIcons?: boolean;
  className?: string;
}

export const OpenChatMessageRowUser: React.FC<Props> = ({
  className,
  hideIcons,
  onImprovePrompt,
  message,
  allowImprovement,
}) => (
  <motion.div
    className="my-3 flex justify-start"
    initial={{ opacity: 0, y: 20 }}
    animate={{ opacity: 1, y: 0 }}
    exit={{ opacity: 0, y: -20 }}
    transition={{ type: "spring", stiffness: 500, damping: 30, mass: 1 }}
  >
    <motion.div
      className="flex w-full"
      initial={{ scale: 0.95, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ delay: 0.1, duration: 0.3 }}
    >
      <div className={twMerge("ml-auto", className)}>
        <S.Container className="rounded-md p-5 text-sm text-white">
          <MarkdownRenderer content={message.content} evidences={[]} processCitations={true} />
        </S.Container>
        <div className="flex gap-1">
          {allowImprovement && (
            <>
              <OpenChatMessageRowImprove onImprovePrompt={onImprovePrompt} content={message.content} />
              <OpenChatMessageRowAddToPromptLibrary content={message.content} />
            </>
          )}
        </div>
      </div>
      {!hideIcons && (
        <div className="ml-2">
          <User style={{ width: 16, height: 16 }} />
        </div>
      )}
    </motion.div>
  </motion.div>
);
